import script from "./sw-item-inputter.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-inputter.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-inputter.vue?vue&type=style&index=0&id=53015d82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53015d82"]])

export default __exports__